import { Partner } from '../../partner/models/partner';
import { ScanCard } from '../../vu/models/scan-card';

export class ScanPartnerCodeInfo {
  partner: Partner;
  card: ScanCard;
  isNewCard: boolean;
  personalNumberExist: boolean;

  constructor(
    partner: Partner,
    card: ScanCard,
    isNewCard = false,
    personalNumberExist = false,
  ) {
    this.partner = partner;
    this.card = card;
    this.isNewCard = isNewCard;
    this.personalNumberExist = personalNumberExist;
  }
}
